import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col gap-3"
};
const _hoisted_2 = { class: "text-sm font-bold text-eblack-900" };
const _hoisted_3 = {
    key: 0,
    class: "rounded-lg border border-ewhite-200 bg-white p-4 text-center text-sm text-eblack-500"
};
const _hoisted_4 = {
    key: 1,
    class: "rounded-lg border border-red-200 bg-red-50 p-4 text-center text-sm text-red-700"
};
const _hoisted_5 = {
    key: 2,
    class: "flex flex-col items-center gap-1 rounded-lg border border-ewhite-200 bg-white p-6 text-center"
};
const _hoisted_6 = { class: "text-sm font-semibold text-eblack-700" };
const _hoisted_7 = { class: "max-w-xs text-xs text-eblack-400" };
const _hoisted_8 = {
    key: 3,
    class: "flex flex-col gap-3"
};
const _hoisted_9 = { class: "flex items-center justify-between gap-2" };
const _hoisted_10 = { class: "flex items-center gap-0.5" };
const _hoisted_11 = { class: "text-xs text-eblack-400" };
const _hoisted_12 = { class: "whitespace-pre-line text-sm text-eblack-600" };
const _hoisted_13 = {
    key: 0,
    class: "whitespace-pre-line rounded-md bg-white px-2.5 py-2 text-xs text-eblack-600"
};
const _hoisted_14 = ["disabled"];
import { computed, onMounted } from "vue";
import { IconStar } from "@tabler/icons-vue";
import { useCatalogServiceReviews } from "@/domains/reviews";
import { formatDateLong } from "@/domains/shared/utils/date-utils";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { FEATURE_FLAGS } from "@/constants/feature-flags";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CatalogServiceReviews',
    props: {
        serviceId: {}
    },
    setup(__props) {
        const props = __props;
        const featureFlagStore = useFeatureFlagStore();
        const isFeatureEnabled = computed(() => featureFlagStore.isRuntimeEnabled(FEATURE_FLAGS.REVIEWS));
        const { reviews, isLoadingReviews, reviewsError, hasMoreReviews, loadReviews, loadMoreReviews, } = useCatalogServiceReviews();
        onMounted(() => {
            if (isFeatureEnabled.value) {
                loadReviews(props.serviceId);
            }
        });
        return (_ctx, _cache) => {
            return (isFeatureEnabled.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t("reviews.catalog.detail.title")), 1),
                    (_unref(isLoadingReviews) && _unref(reviews).length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t("reviews.catalog.detail.loading")), 1))
                        : (_unref(reviewsError))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(reviewsError)), 1))
                            : (_unref(reviews).length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_unref(IconStar), { class: "h-8 w-8 text-eblack-300" }),
                                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("reviews.catalog.detail.empty.title")), 1),
                                    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("reviews.catalog.detail.empty.description")), 1)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reviews), (review) => {
                                        return (_openBlock(), _createElementBlock("article", {
                                            key: review.id,
                                            class: "flex flex-col gap-1.5 rounded-lg border border-ewhite-200 bg-ewhite-50 p-3"
                                        }, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                                                        return _createElementVNode("svg", {
                                                            key: star,
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            viewBox: "0 0 24 24",
                                                            class: _normalizeClass(["h-3.5 w-3.5", star <= review.rating ? 'fill-amber-400 text-amber-400' : 'fill-transparent text-eblack-300']),
                                                            stroke: "currentColor",
                                                            "stroke-width": "1.5",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "aria-hidden": "true"
                                                        }, [...(_cache[1] || (_cache[1] = [
                                                                _createElementVNode("path", { d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" }, null, -1)
                                                            ]))], 2);
                                                    }), 64))
                                                ]),
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(formatDateLong)(review.submitted_at.slice(0, 10))), 1)
                                            ]),
                                            _createElementVNode("p", _hoisted_12, _toDisplayString(review.comment || "—"), 1),
                                            (review.provider_reply)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(review.provider_reply.body), 1))
                                                : _createCommentVNode("", true)
                                        ]));
                                    }), 128)),
                                    (_unref(hasMoreReviews))
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "self-center rounded-lg border border-ewhite-300 px-3 py-1.5 text-xs font-semibold text-eblack-700 transition hover:bg-ewhite-100 disabled:cursor-not-allowed disabled:opacity-60",
                                            disabled: _unref(isLoadingReviews),
                                            onClick: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_unref(loadMoreReviews) && _unref(loadMoreReviews)(...args)))
                                        }, _toDisplayString(_unref(isLoadingReviews) ? _ctx.$t("reviews.catalog.detail.loading") : _ctx.$t("reviews.catalog.detail.load_more")), 9, _hoisted_14))
                                        : _createCommentVNode("", true)
                                ]))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
